import GridContainer from "../components/GridContainer";
import ProjectDetails from "../components/projects/ProjectDetails";
import ProjectBody from "../components/projects/ProjectBody";
import TextLink from "../components/TextLink";
import ProjectTitle from "../components/projects/ProjectTitle";
import ProjectHero from "../components/projects/ProjectHero";
import LinkCard from "../components/projects/LinkCard";
import Divider from "../components/projects/Divider";
import ProjectMedia from "../components/Media";

export default function ProjectR() {
    return (
        <GridContainer>
            <ProjectHero content="https://imgur.com/mXzwKoo.png" />
            <ProjectTitle role="indie game">PROJECT R</ProjectTitle>
            <ProjectBody col={2}>
                This project is an indie action game I just started at June 11, 2025 I'm developing using Unity and C#. I'm currently handling all aspects of development including game design, programming, story writing, overall project direction and art creation (via <TextLink link="https://www.aseprite.org/">Aseprite</TextLink>) my go to pixel art program.

                this is an action rogue like game, I'm actively writing the story, animating characters, and experimenting with combat systems. I'm also exploring different concepts for the world map, enemies, and character designs. The project is in its early stages, and I'm using this time to prototype and refine ideas.
            </ProjectBody>
            <ProjectDetails
                role={['Developer']}
                collaborators={['-']}
                duration={['June 2025 - Present']}
                tools={['Unity', 'C#', 'Aseprite']}
            />
            <Divider />
            {/* <ProjectBody title="KASHIMA MUSIC WEB CONTROLLER"></ProjectBody> */}
            <ProjectBody title="DEVELOPMENT">
                In  the early stages I focused on modularity of my code and scripts since It will be a huge help in the future.
                
                During my asset creation phase I have explored a bunch of style for the characters and I decided to stick in this pixel-art chibi anime style character. 

                I also looked at other games that I play and inspired the UI on those games. and even adapted some game mechanics and system.
            </ProjectBody>
            <ProjectBody title="ANIMATIONS & EFFECTS">
                Players can Sprint, Dash for invincibility frames, Switch Weapons, Equip different weapons. similar to mechanics found in games like Hades, Enter the gungeon, Souls games (Elden ring, Dark Souls, Bloodborne) which are my key inspirations for my game.
             <ProjectMedia isVideo src="/assets/Movement_Showcase.mp4" />
            </ProjectBody>
            <ProjectBody>
                Taking damage will make the camara shake, animate the HP Bar similar to Souls games (Elden ring, Dark Souls). During healing when the player is drinking the flask the player can still move but will move on a decreased movement speed
             <ProjectMedia isVideo src="/assets/Healing_Anim_Showcase.mp4" />
            </ProjectBody>
            <ProjectBody>
                The weapon animations depend on which weapon u equip. each weapon is unique and have their own attack patterns. some weapons have 3 attack combo, some have 4 or more. depending on the rarity of the weapon it will have more attack patterns. The weapon switching is inspired on DMC (Devil May Cry) games.
             <ProjectMedia isVideo src="/assets/Combat_Anim_Showcase.mp4" />
            </ProjectBody>
            <ProjectBody>
                Entering a Combat Area the player will be locked inside that area until the player clears the room and the player can proceed to the next room. Killing enemies makes the player earn Souls which is the currency of the game that can be used to upgrade stats, level up and add status effects on weapons. Rooms have Traps like Holes and spike traps.
             <ProjectMedia isVideo src="/assets/Combat_Room.mp4" />
            </ProjectBody>
            <ProjectBody>
                Players can fall into the hole if they miscalculate their dash or dash attack, as shown in the video below. Falling causes the player to take damage, and they will respawn afterward.
                <ProjectMedia isVideo src="/assets/Trap_Showcase.mp4" />
            </ProjectBody>
            <ProjectBody title="PROCEDURALLY GENERATED ROOMS">
                Rooms are procedurally Generated so no playthrough is always the same each room layout will be unique per floor and everytime you play the game. in the video below I have designed 2 room prefab as of now since I am still actively working on creating room assets. 
             <ProjectMedia isVideo src="/assets/Generate_Room.mp4" />
            </ProjectBody>

            <ProjectBody title="SEE MORE OF MY PROGRESS BELOW">
                Below is some early development footage showcasing my progress.
            </ProjectBody>
            <Divider />
            <ProjectBody title="ATTACK ANIMATIONS SHOWCASE">
                Below is a showcase of attack pattern animations for the katana and dagger. I later split these into separate attacks to set them up as attack sequences in my animator inside unity.
             <ProjectMedia isVideo src="/assets/Katana_Anim.mp4" />
             <ProjectMedia isVideo src="/assets/Dagger_Anim.mp4" />
             </ProjectBody>
             <ProjectBody title="STATUS EFFECTS">
                Inspired by my love for Elden Ring and Nightreign, I have implemented Status effects into the game. I added Bleed which is just blood loss in elden ring, which triggers a burst of damage once a threshold is reached. I also implemented poison which deals damage overtime.
             <ProjectMedia isVideo src="/assets/Bleed_Status_Demo.mp4" />
            </ProjectBody>
            <ProjectBody title="COMBAT SHOWCASE">
                The video below is recorded on July 21, 2025. This is the time I got enemy AI working and sword animations polished with slash animation. along with the UI working such as HP bar animation and healing of player
             <ProjectMedia isVideo src="/assets/combat_showcase_early.mp4" />
            </ProjectBody>
            <ProjectBody title="MULTI-PLATFORM">
                I want this game to be played on multiple devices such as Mobile phone, SteamDeck, PC so while developing I focused on modularity and clean code and add controller support for PC, SteamDeck or any handheld owners and also use my controller rules that can be also applied on mobile controls.
             <ProjectMedia isVideo src="/assets/controller_support.mp4" />
            </ProjectBody>
            
        </GridContainer>
    )
}